// extracted by mini-css-extract-plugin
var _1 = "UserProfileHeaderFooter-modulefooter__QSi7F";
export { _1 as "footer" }
